/* Trang luận giải — lấy bản đọc từ API rồi vẽ.
 *
 * Mã phiên đi qua MẢNH NEO `#s=<uuid>`, không qua tham số. Mảnh neo không được gửi lên
 * máy chủ, không lọt nhật ký truy cập, không lọt Referer. Mã phiên là chìa khoá đọc bản
 * riêng của từng người nên phải ở chỗ ít dấu vết nhất.
 *
 * Không tự đoán quyền: máy chủ trả `access` là gì thì vẽ theo đúng thế. Chưa trả tiền thì
 * API trả bản rút gọn, việc chặn nằm ở đó chứ không nằm ở đây — chặn bằng JS thì mở
 * DevTools là qua.
 */
(function () {
  var goc = document.querySelector('[data-plg]');
  if (!goc) return;

  var API = (goc.getAttribute('data-goc') || '').replace(/\/+$/, '');
  var oTai = goc.querySelector('[data-plg-dang-tai]');
  var oThieu = goc.querySelector('[data-plg-thieu-ma]');
  var oLoi = goc.querySelector('[data-plg-loi]');
  var oND = goc.querySelector('[data-plg-noi-dung]');
  var nutThuLai = goc.querySelector('[data-plg-thu-lai]');
  var oDay = goc.querySelector('[data-plg-day]');
  var oTam = goc.querySelector('[data-plg-tam]');
  var oTamDs = goc.querySelector('[data-plg-tam-ds]');
  var nutMucLuc = goc.querySelector('[data-plg-muc-luc]');

  function hien(el) {
    [oTai, oThieu, oLoi, oND].forEach(function (e) {
      if (e) e.hidden = (e !== el);
    });
    /* C25 chỉ có nghĩa khi bản đọc đang hiện. */
    if (oDay) oDay.hidden = (el !== oND);
    if (el !== oND) dongMucLuc();
  }

  /* Chỉ nhận dạng uuid. Mã lạ thì đừng ghép vào địa chỉ rồi gọi đi — đó là chữ người lạ
     đưa vào qua thanh địa chỉ. */
  var UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

  function layMa() {
    /* Fragment trước — nhưng thường nó đã bị dọn khỏi thanh địa chỉ ngay trong <head>
       (xem đầu <head> của layout/theme.liquid) để pixel không đọc được mã phiên. Nên chỗ
       lấy được thật hay là bộ nhớ phiên. */
    var h = window.location.hash || '';
    var m = h.match(/[#&]s=([^&]+)/);
    var ma = m ? decodeURIComponent(m[1]).trim() : '';
    if (!ma) {
      try { ma = (sessionStorage.getItem('ms_phien') || '').trim(); } catch (e) { ma = ''; }
    }
    return UUID.test(ma) ? ma : '';
  }

  /* Token QA preview: địa chỉ có ?preview=<token> thì chuyền xuống API để nó mở bậc cao
     nhất mà không cần đơn hàng thật. Chỉ dùng khi tự tay mở link kiểm tra — token là secret
     nội bộ (TEST_HARNESS_TOKEN bind ở Cloudflare), không phát cho khách. Thiếu thì gọi như
     thường. Máy chủ fail-closed: token sai hoặc chưa cấu hình đều rơi về bản free. */
  function duongDanKQ(ma) {
    var url = API + '/api/quiz/result/' + encodeURIComponent(ma);
    var m = (window.location.search || '').match(/[?&]preview=([^&]+)/);
    if (m && m[1]) url += '?preview=' + encodeURIComponent(decodeURIComponent(m[1]));
    return url;
  }

  /* ─────────────────────────────────────────────────────────────────────────
     PHẦN VẼ nằm ở bộ vẽ chung `PheuBanDoc.renderReading` của repo `mine_chapter`
     (`public/reader/`), nạp từ `{goc_api}/reader/…` — cùng bộ vẽ tab Destiny của app dùng.
     Sửa cách vẽ bản đọc thì sửa ở đó. File này chỉ còn phần riêng của trang: mã phiên ở
     `#s=`, thanh C1/C25, hỏi lại bậc sau checkout, đích nhảy từ email, link neo, nút Back.
     ───────────────────────────────────────────────────────────────────────── */
  var BD = window.PheuBanDoc || null;
  /* Bản duyệt nội bộ `?duyet=1`: hiện chip `{…}` và khung chờ ảnh. Không dùng `?preview=`:
     token đó mở bậc trả tiền ở API cho QA, gắn chip vào nó thì QA không còn xem được bản khách
     của bậc trả tiền. Mặc định là bản khách — không chip nào (chủ dự án chốt 23/09). */
  if (BD) BD.datDuyet(/[?&]duyet=1(?:&|$)/.test(window.location.search || ''));

  /* Payload đang hiện trên màn. Trang chỉ đọc `access` của nó — bộ vẽ tự đọc phần còn lại. */
  var duLieu = null;

  function bac() {
    return (duLieu && duLieu.access) || 'free';
  }

  function chuGon(t) {
    var d = document.createElement('div');
    d.textContent = t == null ? '' : String(t);
    return d.innerHTML;
  }

  /* Trả danh sách mục cho Contents, hoặc `null` khi bộ vẽ không nạp được hay payload không có
     nội dung đọc nào — lúc đó `oND` không bị đụng. Ngày sinh gửi xong (C23) thì tải lại bản
     đọc: lá số mới về thì khối nối và Phần 2 tự hiện. */
  function veTrang(kq) {
    if (!BD || !BD.renderReading) return null;
    return BD.renderReading(oND, kq, {
      apiBase: API,
      imageBase: goc.getAttribute('data-goc-anh') || '',
      sessionId: layMa(),
      onBirthSaved: function () { goi(); }
    });
  }

  /* ─────────────────────────────────────────────────────────────────────────
     ĐÍCH NHẢY TỪ EMAIL — K26 mục 4: email giao hàng có hai link nhảy, tới mục của vùng thấp
     nhất và tới Tài liệu 2 mục 1. Link là `#s=<uuid>&to=area` và `#s=<uuid>&to=who`. Khối C2
     trong email (K52) thêm `#s=<uuid>&to=plan`.

     Đích đi CÙNG mã phiên trong mảnh neo, không thành tham số: mảnh neo là chỗ duy nhất
     Đầu <head> của `layout/theme.liquid` dọn khỏi thanh địa chỉ trước khi pixel chạy, và nó cất
     đích vào `ms_nhay` cùng lúc cất mã.

     Mỗi đích là danh sách chỗ thử theo thứ tự, vì bản đọc không cố định:
       area · neo K44 `#area-<vùng>` mà C2 trỏ tới (`[data-kh-vung]` giữ đích đó), rồi
              `report7/b3` "Each area up close", rồi `b2` "Your 7-area map" — hai mục cũ
              của payload 2.1 chưa có thẻ vùng.
       who  · tiêu đề "Who you are beneath the roles you carry" — ba đoạn lời thường mở mục 1
              (K31, migration 20261022), bám bằng id khối. Không có thì về `map/s1`. Khách
              bỏ qua ngày sinh thì không có Tài liệu 2: về form ngày sinh (C23).
       plan · neo K44 `#plan` — mục "Your plan of action" (mục chứa `three_steps`).
     Không thấy chỗ nào thì đứng ở đầu trang như link thường.

     Đích được giữ tới khi bản ĐÃ TRẢ TIỀN hiện ra: khách bấm email lúc webhook chưa về thì
     thấy bản miễn phí trước, rồi `doiBac()` vẽ lại — lúc đó phải nhảy lại. Sau đó thì bỏ,
     để form ngày sinh gửi xong vẽ lại mà không kéo khách đi đâu.
     ───────────────────────────────────────────────────────────────────────── */
  var DICH = {
    area: ['[data-kh-vung]', '[data-tl="report7"] [data-muc="b3"]', '[data-tl="report7"] [data-muc="b2"]'],
    plan: ['#plan'],
    who: ['[data-khoi="d22f0000-0000-4000-8000-000000000022"]', '[data-tl="map"] [data-muc="s1"]', '[data-sinh]']
  };
  var daNhay = false;

  function layDich() {
    var m = (window.location.hash || '').match(/[#&]to=([a-z]+)/);
    var d = m ? m[1] : '';
    if (!d) {
      try { d = sessionStorage.getItem('ms_nhay') || ''; } catch (e) { d = ''; }
    }
    return Object.prototype.hasOwnProperty.call(DICH, d) ? d : '';
  }

  /* `instant`: theme đặt `scroll-behavior: smooth` cho cả trang, cuộn mượt qua cả bản đọc
     dài thì chậm và dễ đứt giữa chừng. Khoảng chừa cho header nằm ở CSS. */
  function cuonToi(el) {
    el.scrollIntoView({ block: 'start', behavior: 'instant' });
  }

  /* `[data-kh-vung]` là cái link "Go to your lowest area" trong C2: đích thật là `href` của
     nó, do payload phát. */
  function tim(chon) {
    try { return chon ? oND.querySelector(chon) : null; } catch (e) { return null; }
  }

  function timDich(chon) {
    var el = tim(chon);
    if (el && chon === '[data-kh-vung]') el = tim(el.getAttribute('href'));
    return el;
  }

  function nhayToiDich() {
    var ds = daNhay ? null : DICH[layDich()];
    if (!ds) return;
    if (bac() !== 'free') {
      daNhay = true;
      try { sessionStorage.removeItem('ms_nhay'); } catch (e) {}
    }
    for (var i = 0; i < ds.length; i++) {
      var dich = timDich(ds[i]);
      if (dich) { cuonToi(dich); return; }
    }
  }

  /* ── C25 · "‹ Back" và "Contents" (K44), và nút ‹ của C1.
     Nhảy trong trang không đi qua lịch sử trình duyệt (mảnh neo giữ mã phiên, xem dưới), nên
     "Back" tự nhớ chỗ đứng trước mỗi lần nhảy và trả khách về đó. Chưa nhảy lần nào thì là
     "back" của trình duyệt. */
  var chongLui = [];

  function nhayToi(dich) {
    chongLui.push(window.scrollY);
    cuonToi(dich);
  }

  function lui() {
    dongMucLuc();
    if (chongLui.length) window.scrollTo({ top: chongLui.pop(), behavior: 'instant' });
    else if (window.history.length > 1) window.history.back();
  }

  /* Mục lục = danh sách `renderReading` trả về: mọi đầu mục C3 có neo do payload phát + hai
     dòng phụ khối giải pháp (`sub`), theo đúng thứ tự trên trang. */
  function dungMucLuc(ds) {
    if (!oTamDs) return;
    var ra = '';
    for (var i = 0; i < ds.length; i++) {
      ra += '<li' + (ds[i].sub ? ' class="bd-c25__phu"' : '') + '><a href="#' + chuGon(ds[i].id) + '">' + chuGon(ds[i].title) + '</a></li>';
    }
    oTamDs.innerHTML = ra;
    if (nutMucLuc) nutMucLuc.disabled = !ra;
  }

  function dongMucLuc() {
    if (oTam) oTam.hidden = true;
    if (nutMucLuc) nutMucLuc.setAttribute('aria-expanded', 'false');
  }

  goc.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;
    if (t.closest('[data-plg-lui]')) { lui(); return; }
    if (t.closest('[data-plg-muc-luc]')) {
      var mo = oTam && oTam.hidden;
      if (oTam) oTam.hidden = !mo;
      nutMucLuc.setAttribute('aria-expanded', mo ? 'true' : 'false');
      return;
    }
    var a = t.closest('[data-plg-tam] a[href^="#"]');
    if (a) { e.preventDefault(); dongMucLuc(); var d = tim(a.getAttribute('href')); if (d) nhayToi(d); return; }
    if (t === oTam) dongMucLuc();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') dongMucLuc(); });

  if (oND) {
    /* Link neo trong trang (`#plan`, `#part2`, `#area-*`…) KHÔNG được đổi mảnh neo: mã phiên
       sống ở đó (`#s=<uuid>`), và đổi mảnh neo là nổ `hashchange` → tải lại cả bản đọc.
       Cuộn tay tới đích thay cho trình duyệt. */
    oND.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!a || !oND.contains(a)) return;
      var dich = tim(a.getAttribute('href'));
      e.preventDefault();
      if (dich) nhayToi(dich);
    });
  }


  function hienNoiDung(kq) {
    if (!kq || typeof kq !== 'object') { hien(oLoi); return; }
    /* Bộ vẽ trả `null` khi máy chủ không trả nội dung thật nào — 200 rỗng hoặc thân rác.
       `hienNoiDung` còn là đích của vòng hỏi lại bậc, nên một thân rỗng có thể tới TRONG LÚC
       khách đang đọc. Lần đầu thì hiện màn lỗi; đã có bản đọc trên màn rồi thì giữ nguyên,
       đừng lấy mất thứ đang đọc dở vì một câu trả lời hỏng. */
    var muc = veTrang(kq);
    if (!muc) { if (!duLieu) hien(oLoi); return; }

    duLieu = kq;
    /* Máy chủ nói `access` là gì thì theo đúng thế — không tự đoán quyền ở trình duyệt. */
    oND.setAttribute('data-access', kq.access || 'free');
    dungMucLuc(muc);
    hien(oND);
    nhayToiDich();

    /* `access` KHÔNG chốt tại lúc tải: tiền về qua webhook Shopify sau khi khách đã đứng
       trước trang, nên một phiên có thể nhảy `free` → `full` ngay dưới chân người đọc. Đây
       là đường đi thường gặp nhất của trang này — khách bấm từ trang cảm ơn.

       Hỏi lại mỗi 5 giây, tối đa 12 lần (một phút). Máy chủ cho 30 lượt/phút/IP và trả 429
       sau đó, tài liệu dặn đừng nhanh hơn 3 giây một lần.

       Đổi bậc thì VẼ LẠI TỪ ĐẦU bằng payload mới, không vá payload cũ: bản trả tiền không
       phải bản miễn phí được lấp chỗ trống — `s5` và `s6` là hai chương khác nhau ở hai bậc
       và số khối không khớp nhau. */
    if (bac() === 'free') doiBac();
  }

  var demHoiLai = 0;

  function doiBac() {
    if (demHoiLai >= 12) return;
    demHoiLai++;
    setTimeout(function () {
      var ma = layMa();
      if (!ma) return;
      fetch(duongDanKQ(ma), {
        headers: { Accept: 'application/json' },
        credentials: 'omit'
      }).then(function (res) {
        if (!res.ok) throw new Error('http ' + res.status);
        return res.text().then(function (chu) { return JSON.parse(chu); });
      }).then(function (d) {
        if (d && (d.access || 'free') !== 'free') { hienNoiDung(d); return; }
        doiBac();
      })['catch'](function () {
        /* Hỏi hụt thì thôi, đừng đụng vào thứ khách đang đọc. Vẫn còn nút tải lại. */
        doiBac();
      });
    }, 5000);
  }

  function goi() {
    var ma = layMa();
    if (!ma) { hien(oThieu); return; }

    hien(oTai);
    fetch(duongDanKQ(ma), {
      headers: { Accept: 'application/json' },
      credentials: 'omit'
    }).then(function (res) {
      /* 429 là chạm giới hạn gọi, 404 là mã sai hoặc hết hạn. Khách không phân biệt được
         hai thứ đó, và nói ra cũng không giúp gì — gộp về một lời nhắn. */
      if (!res.ok) throw new Error('http ' + res.status);
      /* KHÔNG tin `content-type`. Máy chủ API đang khai `text/html` cho một thân JSON hợp lệ
         (đo 29/08) — tin header thì từ chối đúng bản đọc thật.
         Thân bài mới là bằng chứng: đọc chữ rồi tự phân tích. Không phải JSON thì `JSON.parse`
         ném lỗi, rơi vào nhánh lỗi — vẫn chặn được trang HTML trả về kèm mã 200, mà không
         chặn nhầm response đúng. */
      return res.text().then(function (chu) { return JSON.parse(chu); });
    }).then(function (du_lieu) {
      hienNoiDung(du_lieu);
    })['catch'](function () {
      hien(oLoi);
    });
  }

  if (nutThuLai) nutThuLai.addEventListener('click', goi);
  /* Khách đổi mảnh neo mà không tải lại trang — hiếm, nhưng rẻ để đỡ. */
  window.addEventListener('hashchange', goi);

  goi();
})();
